import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReceiptUrl from './ReceiptUrl';
import Translation from '../../shared/Translation';
import { getLocation, getTime, getTimezone } from '@checkout-h/listingBannerHelpers';

class EventSummary extends Component {
    render() {
        return(
            <div className={this.getWrapperCSSClass()}>
                <div className="event-summary__details">
                    <h2 className="event-summary__name">
                        <Translation
                          interpolation={{
                            event_name: this.props.name
                          }}
                        >
                          {'checkout__tickets_for_event'}
                        </Translation>
                    </h2>
                    {!this.props.isRecurring && <div className="event-summary__dates">
                        <span>
                            {getTime(
                                this.props.uiConfig,
                                this.props.isRecurring,
                                this.props.start,
                                this.props.end,
                                this.props.locale
                            )}
                            {' '}
                            {getTimezone(this.props.uiConfig, this.props.timezone)}
                        </span>
                    </div>}
                    {!this.props.uiConfig.hide_venue &&
                    <div className="event-summary__location">
                        <address>
                            <span className="event-summary__location-name">{getLocation(this.props.uiConfig, this.props.venueName, this.props.venueAddress)}</span>
                        </address>
                    </div>
                    }
                    {!this.props.hideAgeLimit && (
                      <div className="event-summary__location">
                          <Translation>{this.props.ages}</Translation>
                      </div>
                    )}
                </div>
                {(this.props.location === "confirmation" && !!this.props.receiptUrl) && <ReceiptUrl url={this.props.receiptUrl} />}
            </div>
        )
    }

    getWrapperCSSClass = () => {
        if(!this.props.location) {
            return "tickets__event-summary";
        }

        if(this.props.location === "confirmation") {
            return "confirmation-event-details";
        }
    }

    getImageUrl = () => {
        return "url(" + this.props.image + ")";
    }
}

EventSummary.propTypes = {
    locale: PropTypes.string.isRequired,
    name: PropTypes.string,
    start: PropTypes.string,
    venueName: PropTypes.string,
    venueAddress: PropTypes.string,
    image: PropTypes.node, // not sure if this is the right proptype for image
    location: PropTypes.string,
    uiConfig: PropTypes.object,
    childEvent: PropTypes.any,
    receiptUrl: PropTypes.string,
    hideEventDateTime: PropTypes.bool,
    ages: PropTypes.string,
    hideAgeLimit: PropTypes.bool
}

export default EventSummary
